export default function getHourToMinutes(fullHour) {
  const [hourStr, minutesStr] = fullHour.split(':');
  const hour = Number(hourStr);
  const minutes = Number(minutesStr);

  if (Number.isNaN(hour) || Number.isNaN(minutes)) {
    throw new Error(`Invalid time format: ${fullHour}`);
  }

  return hour * 60 + minutes;
}
